module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "m-table UserForm"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user),
      expression: "user.user"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "user", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("type")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "type"
    },
    on: {
      "select": _vm.select
    },
    model: {
      value: (_vm.watch.type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "type", $$v)
      },
      expression: "watch.type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("office")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.office,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "office"
    },
    on: {
      "select": _vm.select
    },
    model: {
      value: (_vm.watch.office),
      callback: function($$v) {
        _vm.$set(_vm.watch, "office", $$v)
      },
      expression: "watch.office"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42680b2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Form/UserForm.vue
// module id = 1353
// module chunks = 0